interface RichTextProps {
  text: string;
  headingClassName?: string;
  paragraphClassName?: string;
}

export default function RichText({
  text,
  headingClassName = "font-heading font-semibold text-lg text-foreground-950",
  paragraphClassName = "mt-2 text-sm",
}: RichTextProps) {
  const sections = text.trim().split(/\n\s*\n/).filter(Boolean);

  return (
    <>
      {sections.map((section, i) => {
        const lines = section.split("\n");
        const isHeading = lines[0].startsWith("## ");
        const heading = isHeading ? lines[0].slice(3).trim() : null;
        const body = (isHeading ? lines.slice(1) : lines).join(" ").trim();
        return (
          <div key={i} className={i > 0 ? "mt-8" : ""}>
            {heading && <h2 className={headingClassName}>{heading}</h2>}
            {body && <p className={heading ? paragraphClassName : ""}>{body}</p>}
          </div>
        );
      })}
    </>
  );
}
